module.exports = __webpack_public_path__ + "static/media/amex.47c1f98b.svg";